import { useEffect, useMemo } from 'react';
import useApi from "./useApi.js";
export function useCreateClient(serverUrl, options) {
  var api = useApi();
  var client = useMemo(() => new api.CoreClient(serverUrl, options), [api, serverUrl, options]);
  useEffect(() => () => {
    client.disconnect();
  }, [client]);
  return client;
}
export default useCreateClient;
//# sourceMappingURL=useCreateClient.js.map